import { useQuery } from "@tanstack/react-query";

export function useCurrentUserTimezone(): string {
  const { data } = useQuery<{ timezone?: string }>({
    queryKey: ["users", "me"],
    queryFn: () => fetch("/api/users/me", { credentials: "include" }).then(r => r.json()),
    staleTime: 5 * 60_000,
  });
  return data?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || "America/Chicago";
}
